import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import localStorageHelper from '../helpers/local-storage-helper'
import AppConstants from '../appConstants'

Vue.use(AclInstaller)

let initialRole = AppConstants.USER_ROLE_ADM;
// if(localStorageHelper.getCurrentUser().profile) {
//   initialRole = localStorageHelper.getCurrentUser().profile.toLowerCase();
// }

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule(AppConstants.USER_ROLE_ADM).generate(),
    editor: new AclRule(AppConstants.USER_ROLE_EDITOR).or(AppConstants.USER_ROLE_ADM).generate(),
    publisher: new AclRule(AppConstants.USER_ROLE_PUBLISHER).or(AppConstants.USER_ROLE_EDITOR).or(AppConstants.USER_ROLE_ADM).generate(),
    // public: new AclRule('public').or('admin').or('editor').generate(),
  }
})
